import { render, staticRenderFns } from "./UserNotFoundCard.vue?vue&type=template&id=8d1c3c98&scoped=true&"
import script from "./UserNotFoundCard.vue?vue&type=script&lang=js&"
export * from "./UserNotFoundCard.vue?vue&type=script&lang=js&"
import style0 from "./UserNotFoundCard.vue?vue&type=style&index=0&id=8d1c3c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1c3c98",
  null
  
)

export default component.exports